import { usePageTogglers } from "@Client/@Composables/application-standalone/page-helpers/usePageToggler";
import { defineComponent, onBeforeUnmount, watch } from "@vue/composition-api";
import ApplicantsInformation from "./applicants/applicants-information.vue";
import ApplicantsSummary from "./applicants/applicants-summary.vue";
import PageTogglerLayout from "../layout/page-toggler-layout.vue";
import { useScrollTopOnLoad } from "@Shared/@Composables/generic/useScrollTopOnLoad";
import PageStepLayout from "@Client/@Modules/application-standalone/components/layout/page-step-layout.vue";
export default defineComponent({
  name: "ApplicantsPage",
  components: {
    PageTogglerLayout,
    ApplicantsInformation,
    ApplicantsSummary,
    PageStepLayout
  },
  props: {
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    emit
  }) {
    useScrollTopOnLoad();
    const {
      handlePageTogglerNavigation,
      showInformationPage,
      togglerMetadata,
      navigateToInformationPage,
      handleNavigateNext,
      handleNavigateBack
    } = usePageTogglers();
    watch(showInformationPage, newValue => {
      emit("update:showInformationPage", newValue);
      emit("show-errors", 0);
    }, {
      immediate: true
    });
    onBeforeUnmount(() => {
      emit("show-errors", 0);
    });
    return {
      showInformationPage,
      handlePageTogglerNavigation,
      togglerMetadata,
      handleNavigateNext,
      handleNavigateBack,
      navigateToInformationPage
    };
  }
});